export const LP006_TEMPLATE_ID = "104126000000393105";
export const INVOICE_YES =
  "Vine insotita de factura in original aferenta achizitiei";
export const INVOICE_NO = "Nu vine insotit de factura";
export const NOT_APPLICABLE = "Nu se aplică";
export const UNSPECIFIED_DESIGNER_CODE = "Nespecificat";
export const getLp006FieldMaxLength = (name) =>
  name === "nrContract" ? 64 : name === "email" ? 254 : 2048;

export const LP006_FIELDS = [
  { name: "nrContract", label: "Număr contract", section: "Date contract" },
  {
    name: "dataContract",
    label: "Data contractului",
    type: "date",
    section: "Date contract",
  },
  { name: "nume", label: "Nume", section: "Date vânzător" },
  { name: "prenume", label: "Prenume", section: "Date vânzător" },
  { name: "adresa", label: "Adresă CI", section: "Date vânzător" },
  { name: "oras", label: "Oraș", section: "Date vânzător" },
  { name: "judet", label: "Județ", section: "Date vânzător" },
  { name: "serieCI", label: "Serie CI", section: "Date vânzător" },
  { name: "nrCI", label: "Număr CI", section: "Date vânzător" },
  { name: "eliberatDe", label: "CI eliberată de", section: "Date vânzător" },
  {
    name: "eliberatLaData",
    label: "Data eliberării CI",
    type: "date",
    section: "Date vânzător",
  },
  { name: "telefon", label: "Telefon", section: "Date vânzător" },
  { name: "email", label: "Email", section: "Date vânzător" },
  { name: "contCurent", label: "Cont curent (IBAN)", section: "Detalii plată" },
  { name: "banca", label: "Banca", section: "Detalii plată" },
  { name: "numeTitularCont", label: "Numele titularului de cont", section: "Detalii plată" },
  { name: "categoria", label: "Categoria", section: "Detalii produs" },
  { name: "brand", label: "Brand", section: "Detalii produs" },
  { name: "model", label: "Model", section: "Detalii produs" },
  {
    name: "codInteriorProdus",
    label: "Cod interior produs",
    optional: true,
    helperText: "Designer code opțional. Dacă lipsește, în contract apare „Nespecificat”.",
    section: "Detalii produs",
  },
  { name: "checkboxOptions", label: "Însoțit de", section: "Detalii produs" },
  {
    name: "detinFactura",
    label: "Factură / bon",
    type: "select",
    options: [INVOICE_YES, INVOICE_NO],
    section: "Detalii produs",
  },
  {
    name: "nrFactura",
    label: "Număr factură",
    section: "Detalii produs",
    conditional: "invoice",
  },
  {
    name: "detinCertificat",
    label: "Certificat / card",
    type: "select",
    options: ["DA", "NU"],
    section: "Detalii produs",
  },
  {
    name: "serieCertificat",
    label: "Serie certificat / card",
    section: "Detalii produs",
    conditional: "certificate",
  },
  {
    name: "pretFinal",
    label: "Preț cuvenit vânzătorului (RON)",
    section: "Preț și clauze",
  },
  {
    name: "alteClauze",
    label: "Alte clauze",
    multiline: true,
    section: "Preț și clauze",
  },
];

const text = (value) => String(value ?? "").trim();
const normalizedText = (value) =>
  text(value)
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();
export const isLp006Contract = (value) => /\bLP006\b/i.test(text(value));
export const getLp006ContractSuffix = (value) => {
  const suffix = text(value).match(/(\d+)$/)?.[1] || "";
  return suffix.length <= 10 ? suffix : "";
};

export const dateInputValue = (value) => {
  const raw = text(value);
  const iso = raw.match(/^(\d{4})-(\d{2})-(\d{2})(?:T.*)?$/);
  const local = raw.match(/^(\d{2})\.(\d{2})\.(\d{4})$/);
  if (!iso && !local) return "";
  const [year, month, day] = iso
    ? iso.slice(1).map(Number)
    : [Number(local[3]), Number(local[2]), Number(local[1])];
  const parsed = new Date(Date.UTC(year, month - 1, day));
  if (
    year < 1900 ||
    parsed.getUTCFullYear() !== year ||
    parsed.getUTCMonth() !== month - 1 ||
    parsed.getUTCDate() !== day
  )
    return "";
  return `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
};

export const lp006AmountCents = (value) => {
  let raw = text(value);
  if (/\s/.test(raw)) {
    if (!/^\d{1,3}(?:[ \u00a0\u202f]\d{3})+(?:[.,]\d{1,2})?$/.test(raw))
      return null;
    raw = raw.replace(/[ \u00a0\u202f]/g, "");
  }
  if (/^\d{1,3}(?:\.\d{3})+(?:,\d{1,2})?$/.test(raw))
    raw = raw.replace(/\./g, "").replace(",", ".");
  else if (/^\d{1,3}(?:,\d{3})+(?:\.\d{1,2})?$/.test(raw))
    raw = raw.replace(/,/g, "");
  else if (/^\d+(?:[.,]\d{1,2})?$/.test(raw)) raw = raw.replace(",", ".");
  else return null;
  const cents = Math.round(Number(raw) * 100);
  return Number.isSafeInteger(cents) && cents > 0 ? cents : null;
};

export const buildLp006Draft = (source = {}) => {
  const draft = Object.fromEntries(
    LP006_FIELDS.map(({ name, type }) => {
      let value =
        name === "nrContract"
          ? source.numarContract || source.nrContract
          : name === "pretFinal"
            ? (source.pretCuvenit ?? source.pretFinal)
            : name === "numeTitularCont"
              ? text(source.numeTitularCont) || [text(source.nume), text(source.prenume)].filter(Boolean).join(" ")
              : source[name];
      if (Array.isArray(value)) value = value.filter(Boolean).join(", ");
      if (type === "date") value = dateInputValue(value);
      return [name, text(value)];
    }),
  );
  if (
    [
      "da",
      "yes",
      "vine insotit de factura in original aferenta achizitiei",
      normalizedText(INVOICE_YES),
    ].includes(normalizedText(draft.detinFactura))
  )
    draft.detinFactura = INVOICE_YES;
  if (
    [
      "nu",
      "no",
      "nu vine insotita de factura",
      normalizedText(INVOICE_NO),
    ].includes(normalizedText(draft.detinFactura))
  )
    draft.detinFactura = INVOICE_NO;
  if (["da", "yes"].includes(normalizedText(draft.detinCertificat)))
    draft.detinCertificat = "DA";
  if (["nu", "no"].includes(normalizedText(draft.detinCertificat)))
    draft.detinCertificat = "NU";
  return draft;
};

export const validateLp006Draft = (draft = {}) => {
  const fields = Object.fromEntries(
    LP006_FIELDS.map(({ name }) => [name, text(draft[name])]),
  );
  if (fields.detinFactura === INVOICE_NO) fields.nrFactura = NOT_APPLICABLE;
  if (fields.detinCertificat === "NU") fields.serieCertificat = NOT_APPLICABLE;
  if (!fields.codInteriorProdus) fields.codInteriorProdus = UNSPECIFIED_DESIGNER_CODE;
  const errors = {};
  for (const field of LP006_FIELDS) {
    if (!fields[field.name]) errors[field.name] = "Completează acest câmp.";
    else if (field.type === "date") {
      const date = dateInputValue(fields[field.name]);
      if (!date) errors[field.name] = "Introdu o dată validă.";
      else fields[field.name] = date.split("-").reverse().join(".");
    } else if (field.options && !field.options.includes(fields[field.name])) {
      errors[field.name] = "Selectează o opțiune validă.";
    }
  }
  if (fields.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(fields.email))
    errors.email = "Introdu un email valid.";
  if (fields.telefon && !/^\+?[\d ().-]+$/.test(fields.telefon))
    errors.telefon = "Introdu un număr de telefon valid.";
  if (
    fields.telefon &&
    (fields.telefon.replace(/\D/g, "").length < 7 ||
      fields.telefon.replace(/\D/g, "").length > 15)
  )
    errors.telefon = "Introdu un număr de telefon valid.";
  if (fields.nrContract && !getLp006ContractSuffix(fields.nrContract))
    errors.nrContract =
      "Numărul contractului trebuie să se termine cu un cod numeric de cel mult 10 cifre.";
  const cents = lp006AmountCents(fields.pretFinal);
  if (cents === null)
    errors.pretFinal =
      "Introdu o sumă validă, mai mare decât zero, cu cel mult două zecimale.";
  else fields.pretFinal = (cents / 100).toFixed(2);
  if (
    fields.detinFactura === INVOICE_YES &&
    fields.nrFactura === NOT_APPLICABLE
  )
    errors.nrFactura = "Introdu numărul facturii existente.";
  if (
    fields.detinCertificat === "DA" &&
    fields.serieCertificat === NOT_APPLICABLE
  )
    errors.serieCertificat = "Introdu seria certificatului existent.";
  for (const { name } of LP006_FIELDS) {
    const maxLength = getLp006FieldMaxLength(name);
    if (fields[name].length > maxLength) {
      errors[name] = `Introdu cel mult ${maxLength} caractere.`;
    }
    const explicitNoneAllowed = ["alteClauze", "checkboxOptions"].includes(
      name,
    );
    const conditionalNoneAllowed =
      (name === "nrFactura" && fields.detinFactura === INVOICE_NO) ||
      (name === "serieCertificat" && fields.detinCertificat === "NU");
    if (
      !explicitNoneAllowed &&
      (/^(?:n\/?a|null|undefined|-+)$/i.test(fields[name]) ||
        (normalizedText(fields[name]) === "nu se aplica" &&
          !conditionalNoneAllowed))
    ) {
      errors[name] = "Completează acest câmp cu informația corespunzătoare.";
    }
  }
  if (`${fields.nume} ${fields.prenume}`.replace(/\s+/g, " ").length > 255) {
    errors.nume ||=
      "Numele complet al semnatarului poate avea cel mult 255 de caractere.";
    errors.prenume ||=
      "Numele complet al semnatarului poate avea cel mult 255 de caractere.";
  }
  return { fields, errors, isValid: Object.keys(errors).length === 0 };
};
